import EventDetails from './eventDetails/eventDetails';
import Tickets from './tickets/Tickets';
import BookingDetails from './bookingDetails/bookingDetails';
import AttendeesTable from './attendees/attendeesTable';
import Dashboard from './dashboard/dashboard';

export{
  EventDetails,
  Tickets,
  BookingDetails,
  AttendeesTable,
  Dashboard,
}